import './App.css';
import {Routes, Route, Link} from 'react-router-dom';
import logo from "./newlogo.png";
import React from "react";
import {PortionConversion} from "./PortionConversions";

function Home() {
    return <div>
        <h1>Nutricherry Recipe &amp; Conversion Helper</h1>
        <p>Please choose from the choices below to proceed:</p>
        <ul>
            <li><Link to="/conversions">Measurement conversions</Link></li>
        </ul>
        </div>
}

function App() {

    function menuWasToggled(event) {
        let x = document.getElementById("App-sitemenu");
        if (x.style.display === "block") {
            x.style.display = "none";
        } else {
            x.style.display = "block";
        }
    }

    return (
        <div>
            <header className="App-header container">
                <div className="App-topnav">
                    <button type="button" aria-controls="mainMenu" aria-expanded="false" className="App-menu-icon"
                            aria-label="Toggle navigation" onClick={menuWasToggled}>
                        &#9776;
                    </button>
                    <a href="https://www.nutricherry.com"><img src={logo} className="App-logo" alt="logo"/></a>

                    <ul id="App-sitemenu">
                        <li><Link className="App-button" to="conversions">Conversions</Link></li>
                    </ul>
                </div>
            </header>
            <div className="App-content container">
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="conversions" element={<PortionConversion/>}/>
                </Routes>
            </div>
        </div>
    );
}

export default App;
